import dayjs from "dayjs"

// Gives agents time to select and review winners before the automatic reveal.
export const MIN_DAYS_DEADLINE_TO_NOTIFY = 7

export const WINNER_NOTIFICATION_HINT = `When winners see the 'you won' message in My Account and the app. Select and review winners before then. Must be at least ${MIN_DAYS_DEADLINE_TO_NOTIFY} days after the entry deadline and before the winner publication date.`

// Backend enforces deadline < notification < publication; the minimum gap is Nova-only.
export const winnerNotificationDateError = (
  winnerNotificationDateTime: Date | null,
  entryDeadlineDateTime: Date | null,
  winnerPublicationDateTime: Date | null,
): string | undefined => {
  if (!winnerNotificationDateTime) return undefined
  const notifyDate = dayjs(winnerNotificationDateTime)
  if (
    entryDeadlineDateTime &&
    notifyDate.isBefore(
      dayjs(entryDeadlineDateTime).add(MIN_DAYS_DEADLINE_TO_NOTIFY, "day"),
    )
  ) {
    return `Must be at least ${MIN_DAYS_DEADLINE_TO_NOTIFY} days after the entry deadline`
  }
  if (
    winnerPublicationDateTime &&
    !notifyDate.isBefore(winnerPublicationDateTime)
  ) {
    return "Must be before the winner publication date"
  }
  return undefined
}
